import { Outlet } from 'react-router-dom';
import { ConsultationProvider } from '../context/ConsultationContext';

export default function ConsultationMiddleware() {
  return (
    <ConsultationProvider>
      <Outlet />
    </ConsultationProvider>
  );
}
